import React from "react";
import ReactApexChart from "react-apexcharts";

class MultipleRadialBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            series: this.props.y,
            options: {
                chart: {
                    height: 350,
                    type: 'radialBar',
                },
                plotOptions: {
                    radialBar: {
                        dataLabels: {
                            name: {
                                fontSize: '22px',
                            },
                            value: {
                                fontSize: '16px',
                            },
                            total: {
                                show: false,
                                label: 'Total',
                                // formatter: function (val) {
                                //     // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                                //     return val
                                // }
                            }
                        }
                    }
                },
                labels: this.props.x,
            },
        };
    }



    render() {
        return (
            <div id="chart">
                <ReactApexChart
                    options={this.state.options}
                    series={this.state.series}
                    type="radialBar"
                    height={350} />
            </div>
        );
    }
}

export default MultipleRadialBar;